import { useEffect } from "react";

const HEAD = typeof document !== "undefined" ? document.head : null;

function upsertMeta(attr, key, content) {
  if (!HEAD || !content) return;
  let el = document.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    HEAD.appendChild(el);
  }
  el.setAttribute("content", content);
}

function upsertCanonical(href) {
  if (!HEAD || !href) return;
  let link = document.querySelector('link[rel="canonical"]');
  if (!link) {
    link = document.createElement("link");
    link.setAttribute("rel", "canonical");
    HEAD.appendChild(link);
  }
  link.setAttribute("href", href);
}

/**
 * SEO component — manages per-page title, description, keywords, canonical and OG twins.
 * All DOM helpers are module-level (pure), so the effect's only real deps are the props.
 */
export function SEO({ title, description, canonical, keywords }) {
  useEffect(() => {
    if (title) {
      document.title = title;
      upsertMeta("property", "og:title", title);
    }
    if (description) {
      upsertMeta("name", "description", description);
      upsertMeta("property", "og:description", description);
    }
    if (keywords) upsertMeta("name", "keywords", keywords);
    if (canonical) {
      upsertCanonical(canonical);
      upsertMeta("property", "og:url", canonical);
    }
  }, [title, description, canonical, keywords]);

  return null;
}
